











































import auth from '../auth'
import {Component, Vue} from 'vue-property-decorator'
import LoaderButton from '@/components/common/LoaderButton.vue'

@Component({
  components: {
    LoaderButton,
  },
})

export default class Home extends Vue {
  public auth = auth

  private user = {
    name: '',
    password: '',
    nameClass: false,
    passwordClass: false,
  }

  private login() {
    auth.login(this, this.user.name, this.user.password)
  }
  private clearName() {
    this.user.nameClass = true
    this.auth.user.errors.email = ''
  }

  private clearPassword() {
    this.user.passwordClass = true
    this.auth.user.errors.password = ''
  }

}
